export default __webpack_public_path__ + "cc72786c2fb99a9ac201313e55446167-p22mackinac-medium-webfont.woff";